/*
 * WaWiProdukteAppQueries.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-11-02 in huWaWi3 33.4.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import gql from 'graphql-tag';

import {
  AUFTRAGSPOSITION_FRAGMENT,
  BESTANDSBUCHSUMME_FRAGMENT,
  ITEM_FRAGMENT,
  PREIS_FRAGMENT,
  PRODUKT_FRAGMENT,
  RESERVIERUNGSPOSITION_FRAGMENT,
} from '../fragments';

export const SUGGESTIONS_QUERY = gql`
  query ProductSuggenstionsQuery($term: String!) {
    fulltextSearch: h3ProduktSearch(term: $term) {
      id
      designator
      title
      score
    }
  }
`;

export const PRODUKT_LIST_QUERY = gql`
  query ProduktListQuery($cursor: String) {
    nodes: h3ProduktPages(after: $cursor, filter: { ist_aktiv: { eq: true } }) {
      edges {
        cursor
        node {
          ...produktFragment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${PRODUKT_FRAGMENT}
`;

export const PRODUKT_WITH_ITEM_QUERY = gql`
  query ProduktUswLesenQuery($nr: ID!) {
    entity: h3Produkt(designator: $nr) {
      ...produktFragment
      itemList {
        ...itemFragment
      }
    }
  }
  ${PRODUKT_FRAGMENT}
  ${ITEM_FRAGMENT}
`;

export const VERFUEGBARKEITS_PREIS_QUERY = gql`
  query ProduktPreiseLesenQuery($nr: ID!) {
    h3Produkt(designator: $nr) {
      itemList {
        id
        designator
        name
        zusatz
        preis: preisResolved {
          ...preisLFragment
        }
        zukunft {
          buchbestand
          frei_ab
          frei_max
          freie_menge
          naechster_zulauf
          zukuenftiger_zulauf
        }
      }
    }
  }
  ${PREIS_FRAGMENT}
`;

export const BESTAND_LIST_QUERY = gql`
  query PBetQuery($nr: ID!) {
    h3Produkt(designator: $nr) {
      itemList {
        skuMasterList {
          skuList {
            nodes: bestaende {
              ...bestandsbuchsummeFragment
            }
          }
        }
      }
    }
  }
  ${BESTANDSBUCHSUMME_FRAGMENT}
`;
export const RESERVIERUNG_LIST_QUERY = gql`
  query ProduktReservierungenQuery($nr: ID!) {
    h3Produkt(designator: $nr) {
      itemList {
        nodes: reservierungsPositionen(filter: { erledigt: { eq: false } }) {
          ...resevierungspositionFragment
        }
      }
    }
  }
  ${RESERVIERUNGSPOSITION_FRAGMENT}
`;

export const AUFTRAG_LIST_QUERY = gql`
  query ProduktAuftraegeQuery($nr: ID!) {
    h3Produkt(designator: $nr) {
      itemList {
        nodes: auftragsPositionen(filter: { erledigt: { eq: false } }) {
          ...auftragspositionFragment
          kunde {
            id
            name
          }
        }
      }
    }
  }
  ${AUFTRAGSPOSITION_FRAGMENT}
`;
